module.exports = __webpack_public_path__ + "static/media/ferry.5dc41acb.svg";